import angular from 'angular';
import adminpulse from '../../../shared/utils/adminpulse';

angular.module('commonServices').factory('validationSvc', ['flySvc', validationSvc]);

function validationSvc(flySvc) {
  // The regex to test if a string is a guid
  var guidRegex = /^\{?[a-fA-F0-9]{8}-([a-fA-F0-9]{4}-){3}[a-fA-F0-9]{12}\}?$/;

  var ibanReplaceLetters = function(ibanString) {
    ibanString = ibanString.replace('A', '10');
    ibanString = ibanString.replace('B', '11');
    ibanString = ibanString.replace('C', '12');
    ibanString = ibanString.replace('D', '13');
    ibanString = ibanString.replace('E', '14');
    ibanString = ibanString.replace('F', '15');
    ibanString = ibanString.replace('G', '16');
    ibanString = ibanString.replace('H', '17');
    ibanString = ibanString.replace('I', '18');
    ibanString = ibanString.replace('J', '19');
    ibanString = ibanString.replace('K', '20');
    ibanString = ibanString.replace('L', '21');
    ibanString = ibanString.replace('M', '22');
    ibanString = ibanString.replace('N', '23');
    ibanString = ibanString.replace('O', '24');
    ibanString = ibanString.replace('P', '25');
    ibanString = ibanString.replace('Q', '26');
    ibanString = ibanString.replace('R', '27');
    ibanString = ibanString.replace('S', '28');
    ibanString = ibanString.replace('T', '29');
    ibanString = ibanString.replace('U', '30');
    ibanString = ibanString.replace('V', '31');
    ibanString = ibanString.replace('W', '32');
    ibanString = ibanString.replace('X', '33');
    ibanString = ibanString.replace('Y', '34');
    ibanString = ibanString.replace('Z', '35');
    return ibanString;
  };

  // This function validates specific types and holds the rules for it itself
  // returns true if valid, string with errorMsg when validation fails
  var validateType = function(type, value, noFlyIn) {
    switch (type) {
      case 'iban': {
        // regex is for BELGIAN iban number
        if (!/^BE[0-9]{2} [0-9]{4} [0-9]{4} [0-9]{4}$/.test(value)) {
          if (!noFlyIn) flySvc.error(9, ['IBAN']);
          return false;
        }
        // valideer de samenstelling (op basis van de landcode? (eerste twee tekens)
        // zie hierboven
        // verplaats de eerste 4 chars naar achteraan
        var ibanString = value.replace(/ /g, ''); // remove all spaces
        var firstFourChars = ibanString.substring(0, 4);
        var rest = ibanString.substring(4);
        var toTest = rest + firstFourChars;
        // vervang elke letter door twee cijfers (A=10, ... Z=35)
        toTest = ibanReplaceLetters(toTest);
        // getal modulo 97 == 1 => correcte iban
        // we moeten dit in stukken doen omdat het getal te groot is om mee te rekenen in javascript
        var numTest;
        var mod = '';

        while (toTest.length > 9) {
          numTest = mod + toTest.substring(0, 9);
          toTest = toTest.substring(9);
          mod = parseInt(numTest) % 97;
        }
        numTest = mod + toTest;
        mod = parseInt(numTest) % 97;

        if (mod !== 1) {
          if (!noFlyIn) flySvc.error(6005);
          return false;
        }
        return true;
      }
      case 'vatNumber':
      case 'enterpriseNumber': {
        //TODO: Use adminpulse.isValidVATNumber and adminpulse.isValidEnterpriseNumber defined in _Auxiliary.js.
        var fieldName = type === 'vatNumber' ? 'VAT number' : 'Enterprise number';
        if (type === 'vatNumber') {
          var validVat = true;
          var countryMatch = value.match(/^([a-zA-Z]{2}).+$/); //Check country code
          if (countryMatch) {
            if (countryMatch[1].toUpperCase() !== 'BE') return true; //Only do regex and checksum for Belgium vat numbers
            validVat = /^BE [0-9]{4}.[0-9]{3}.[0-9]{3}$/.test(value);
          } else {
            validVat = false;
          }
          if (!validVat) {
            if (!noFlyIn) flySvc.error(9, [fieldName]);
            return false;
          }
        }
        if (type === 'enterpriseNumber' && !/^[0-9]{4}.[0-9]{3}.[0-9]{3}$/.test(value)) {
          if (!noFlyIn) flySvc.error(9, [fieldName]);
          return false;
        }
        var myString = value.replace(/\D/g, ''); // remove all non-digits.
        var number = parseInt(myString.substring(0, myString.length - 2));
        var check = parseInt(myString.substring(myString.length - 2));
        if (97 - (number % 97) !== check) {
          if (!noFlyIn) flySvc.error(9, [fieldName]);
          return false;
        }
        return true;
      }
      case 'email':
      case 'emailReplyTo': {
        var fieldName = type === 'email' ? 'Email address' : 'Reply to email';
        if (!/^[^@]+@.+\..+$/.test(value)) {
          if (!noFlyIn) flySvc.error(9, [fieldName]);
          return false;
        }
        return true;
      }
      case 'mobile':
      case 'phone': {
        //TODO: Use adminpulse.isValidPhoneNumber.
        if (value === null || typeof value === 'undefined') return false;
        if (!adminpulse.isValidPhoneNumber(value)) {
          if (!noFlyIn) flySvc.error(9, ['Phone number']);
          return false;
        }

        return true;
      }
      case 'street':
      case 'street1':
      case 'street2':
      case 'box':
      case 'city': {
        // no validation so far
        return true;
      }
      case 'number': {
        // 0 to 5 digits (so empty is allowed !!! Carla says so...)
        if (!/^[0-9]{0,5}/.test(value)) {
          if (!noFlyIn) flySvc.error(9, ['No.']);
          return false;
        }
        return true;
      }
      case 'webAddress':
      case 'website': {
        if (value === '') return true;
        var regexString =
          '^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?';
        var regex = new RegExp(regexString);
        if (!regex.test(value)) {
          if (!noFlyIn) flySvc.error(9, ['Website']);
          return false;
        }
        return true;
      }
      case 'zipCode': {
        // no validation so far (regex for 4 digits: /^[0-9]{4}$|^$/
        return true;
      }
      case 'invoiceCounter':
      case 'creditNoteCounter': {
        var fieldName =
          type === 'invoiceCounter' ? 'Invoice number start value' : 'Credit note start value';
        var regexString = '[Counter:N[0-9]{1}]';
        var regex = new RegExp(regexString);
        if (!regex.test(value)) {
          if (!noFlyIn) flySvc.error(6016, [fieldName]);
          return false;
        }
        return true;
      }
      default: {
        console.warn('ValidationSvc: unknown type, type = ' + type);
        return true;
      }
    }
  };

  // This function validates fields where validation is in the field definition. Returns true (validation success) or string with errorMsg
  var validateFieldWithDef = function(definition, valueToValidate, relation, blockFlyIn) {
    // if definition.type === 3 (Date) and value is undefined => invalid Date
    if (definition.type === 3 && typeof valueToValidate === 'undefined') {
      if (!blockFlyIn) flySvc.error(16002);
      return false;
    }

    // First check for required
    if (definition.isRequired) {
      // special case: vatNumber: Even when required an empty string should pass, because that means 'not liable'
      if (definition.type === 38) {
        if (valueToValidate === null || typeof valueToValidate === 'undefined') {
          if (!blockFlyIn) flySvc.error(3017);
          return false;
        } else {
          if (valueToValidate !== '' && !validateType('vatNumber', valueToValidate))
            //Other validation function to check the vat number
            return false;
        }
      }

      // all other cases
      if (
        definition.type !== 38 &&
        ((!valueToValidate && valueToValidate !== 0) ||
          // for Date we need to check for the null value (0001-01-01T00:00:00) as well
          (definition.type === 3 &&
            (valueToValidate === '0001-01-01T00:00:00' ||
              valueToValidate === '0001-01-01T00:00:00Z')))
      ) {
        if (!blockFlyIn) flySvc.error(3017);
        return false;
      }
    }

    // If not required, then null is allowed and leads to no further validation
    if (!definition.isRequired && !valueToValidate && valueToValidate !== 0) {
      return true;
    }
    // If no validators are present, return true
    if (!definition.validators) return true;

    var passesValidation = true;
    // The validator(s) are wrapped in an array, so we need to loop over them
    for (var t = 0; t < definition.validators.length; t++) {
      var validator = definition.validators[t];
      if (valueToValidate === null) continue;

      // Each rule is a property of the validator, so we loop again
      angular.forEach(validator, function(refValue, key, obj) {
        switch (key) {
          // Date / number validator - maximum
          case 'maximum': {
            // String validator - maximumLength
            if ([5, 6, 7, 8, 37, 38].indexOf(definition.type) >= 0) {
              if (typeof refValue !== 'number') refValue = parseInt(refValue);
              if (valueToValidate.length > refValue) {
                flySvc.error(8, [refValue]);
                passesValidation = false;
              }
              break;
            }

            var refMaxDate;
            // if maximum === 'TODAY'
            if (typeof refValue === 'string' && refValue === 'TODAY') {
              if (valueToValidate > new Date()) {
                flySvc.error(28);
                passesValidation = false;
              }
              break;
            }
            // if maximum is a GUID (references the value of another field)
            if (typeof refValue === 'string' && guidRegex.test(refValue)) {
              if (typeof relation[refValue].value != 'number') {
                refMaxDate = new Date(relation[refValue].value);
                if (valueToValidate > refMaxDate) {
                  flySvc.error(25, [refValue]);
                  passesValidation = false;
                }
              }
              break;
            }
            // if maximum is another string (we assume it is a Date)
            if (typeof refValue === 'string') {
              refMaxDate = new Date(refValue);
              if (valueToValidate > refMaxDate) {
                flySvc.error(6, [refMaxDate.toDateString]);
                passesValidation = false;
              }
              break;
            }
            // if maximum is a number
            if (typeof refValue === 'number') {
              if (valueToValidate > refValue) {
                if (definition.type === 41) flySvc.error(6, [(refValue * 100).toFixed(2) + '%']);
                else flySvc.error(6, [refValue]);
                passesValidation = false;
              }
              break;
            }
            // if maximum is null or undefined
            if (refValue == null) {
              // Do nothing
              console.debug(
                'Max value for validation of field ' +
                  definition.label +
                  ' ' +
                  definition.id +
                  'is not defined',
              );
              break;
            }
            console.error(
              'Apparently the reference value for maximum is string, number nor null and lacks an implementation',
            );
            break;
          }
          case 'minimum': {
            // Date / number validator - minimum
            // String validator - minimumLength
            if ([5, 6, 7, 8, 37, 38].indexOf(definition.type) >= 0) {
              if (typeof refValue !== 'number') refValue = parseInt(refValue);
              if (valueToValidate.length < refValue) {
                flySvc.error(7, [refValue]);
                passesValidation = false;
              }
              break;
            }

            var refMinDate;
            // if minimum === 'TODAY'
            if (typeof refValue === 'string' && refValue === 'TODAY') {
              if (valueToValidate < new Date()) {
                flySvc.error(29);
                passesValidation = false;
              }
              break;
            }
            // if minimum is a GUID (references the value of another field)
            if (typeof refValue === 'string' && guidRegex.test(refValue)) {
              // if the value in that field is not a number, we assume it is a date
              if (typeof relation[refValue].value != 'number') {
                refMinDate = new Date(relation[refValue].value);
                if (valueToValidate < refMinDate) {
                  flySvc.error(24, [refValue]);
                  passesValidation = false;
                }
              }
              break;
            }
            // if minimum is another string (we assume it is a Date)
            if (typeof refValue === 'string') {
              refMinDate = new Date(refValue);
              if (valueToValidate < refMinDate) {
                flySvc.error(5, [refMinDate.toDateString()]);
                passesValidation = false;
              }
              break;
            }
            // if minimum is a number
            if (typeof refValue === 'number') {
              if (valueToValidate < refValue) {
                if (definition.type === 41) flySvc.error(5, [(refValue * 100).toFixed(2) + '%']);
                else flySvc.error(5, [refValue]);
                passesValidation = false;
              }
              break;
            }
            // if minimum is null or undefined
            if (refValue == null) {
              // no validation
              console.debug(
                'Min value for validation of field ' +
                  definition.label +
                  ' ' +
                  definition.id +
                  'is not defined',
              );
              break;
            }
            console.warn(
              'Apparently the reference value for minimum is string, number nor null and lacks an implementation',
            );
            break;
          }
          case 'regularExpression': {
            // String validator - regex
            if (refValue) {
              var regex = new RegExp(refValue);
              if (!regex.test(valueToValidate)) {
                flySvc.error(9, [definition.id]);
                passesValidation = false;
              }
            }
            console.log(
              'Regex validation for field ' + definition.label + ' lacks a reference value.',
            );
            break;
          }
          case 'vies': {
            // Do vies validation on client?
            console.log('Vies validation from client side is not implemented.');
            break;
          }
          default: {
            console.warn('Validation rule not implemented!' + key + ' ' + refValue);
            break;
          }
        }
      });
    }
    return passesValidation;
  };

  return {
    validateFieldWithDef: validateFieldWithDef,
    validateType: validateType,
  };
}
